<template>
  <section class="cooperator content-box">
    <div class="title">
      <img :src="require('@/assets/images/partner/partner-title.png')" alt="" />
    </div>
    <div class="list">
      <div class="item" v-for="item in list" :key="item.title">
        <p>
          <img :src="item.img" alt="" />
        </p>
        <p>万博倾情赞助</p>
        <h3>{{ item.title }}</h3>
      </div>
    </div>

    <!-- 预加载开始 -->
    <div ref="hideImages">
      <img
        :src="item.banner"
        alt=""
        v-for="(item, index) in sponsorData || []"
        :key="index"
      />
    </div>
    <!-- 预加载结束 -->

    <img :src="background" alt />
  </section>
</template>
<script>
import SectionTitle from '@/components/items/sectionTitle'

export default {
  name: 'Cooperatro',
  props: ['team', 'sponsorData'],
  components: { SectionTitle },
  data() {
    return {
      list: [
        {
          title: '狼队',
          img: require('@/assets/images/partner/item01.png'),
        },
        {
          title: '诺克冠中冠赛',
          img: require('@/assets/images/partner/item02.png'),
        },
        {
          title: '直布罗陀公开赛',
          img: require('@/assets/images/partner/item03.png'),
        },
        {
          title: '威尔士公开赛',
          img: require('@/assets/images/partner/item04.png'),
        },
      ],
    }
  },
  computed: {
    background() {
      const name = this.team || 'premier_league'
      return require(`../../assets/images/${name}/cooperator.png`)
    },
  },
}
</script>

<style lang="less" scoped>
@import '../../assets/css/home';
#top {
  margin-top: 60px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.section-title-wrap {
  width: 60%;
  display: block;
  margin: 0 auto;
}
.cooperator {
  margin-top: -1em;
  position: relative;
  .title {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    text-align: center;
    margin-top :20px;
    img {
      width: 116px;
      margin: 0 auto;
    }
  }
}
</style>
<style lang="less">
@import '../../styles/home';
</style>
<style lang="stylus" scoped>
.list {
  display flex
  justify-content center
  margin-top 110px
  padding 0 10px
  position: absolute;
  left: 0;
  top: 0;
  .item {
    text-align center
    color #fff
    flex 1
    margin-right 20px
    p {
      font-size 12px
      margin 5px 0
    }
    h3 {
      font-size 14px
    }
    &:last-child {
      margin-right 0
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/section/cooperator.vue